function getContentfulCollection(){
   const apiUrl = `https://apiapi.ombligo.com/n_contentful/collection/${collectionHandle}/`;

   fetch(apiUrl)
   .then(response => response.json())
   .then(data => {
       const title = data.items[0].fields.collectionTitle;
       const subtitle = data.items[0].fields.collectionSubTitle;

       fillTitleText(title, '#collection_title');
       if (subtitle !== undefined){
           fillSubtitleText(subtitle, '#collection_description');
       }
       parseDescription(data);
   })
   .catch(error => {
       console.log('Likely No Data:', error);
   });
}
function fillTitleText(data, titleContainer){
    titleContainer = document.querySelector(titleContainer);
    
    if(titleContainer) titleContainer.innerHTML = data;
    }

function fillSubtitleText(data){
    subtitleContainer = document.querySelector('#collection_subtitle');
    subtitleContainer.innerHTML = data;
}

function fillDescriptionText(data, descriptionContainer){
    descriptionContainer = document.querySelector(descriptionContainer);
    if (!descriptionContainer) {
        console.warn(`Description container ${descriptionContainer} not found.`);
        return;
    }
    if (descriptionContainer.classList.contains("dontOverwrite")) {
        descriptionContainer.innerHTML = data + descriptionContainer.innerHTML;
    } else {
        descriptionContainer.innerHTML = data;
    }
}

function parseDescription(data) {
    if (data.items[0].fields.collectionDescriptionLeftSection?.content) {
        const contentNodes = data.items[0].fields.collectionDescriptionLeftSection.content;
        let parsedHtml = '';
        contentNodes.forEach(node => {
            parsedHtml += parseRichText(node);
        });
        fillDescriptionText(parsedHtml, "#collection_description_left");
    }

    if (data.items[0].fields.collectionDescriptionRightSection?.content) {
        const contentNodes = data.items[0].fields.collectionDescriptionRightSection.content;
        let parsedHtml = '';
        contentNodes.forEach(node => {
            parsedHtml += parseRichText(node);
        });
        fillDescriptionText(parsedHtml, "#collection_description_right");
    }

    if (data.items[0].fields.collectionDescription?.content) {
        const contentNodes = data.items[0].fields.collectionDescription.content;
        let parsedHtml = '';
        contentNodes.forEach(node => {
            parsedHtml += parseRichText(node);
        });
        fillDescriptionText(parsedHtml, "#collection_description");
    }

    if (data.includes?.Asset && data.includes.Asset[0]) {
        const imageData = data.includes.Asset[0].fields;
        const imageURL = imageData.file.url.replace('//', 'https://');
        const image = createElement('img', 'collectionImage', '', {
            src: imageURL,
            alt: imageData.description,
            title: imageData.title,
            width: '149px',
            height: '149px'
        });
        document.getElementById('collection_split_image').appendChild(image);
    }
}

getContentfulCollection();


function createElement(tag, attributes = {}, textContent = '') {
    const element = document.createElement(tag);
    for (let key in attributes) {
        element[key] = attributes[key];
    }
    if (textContent) {
        element.textContent = textContent;
    }
    return element;
}





const quizData = {
    currentQuestion: 0,
    answers: {
        customer_type: '',
        selected_solution: [],
        selected_emphasis: []
    }
};

const questions = [
    {
        key: 'customer_type',
        question: 'Will you be using this server for work or personal?',
        context: "From experimenting in a home lab to handling business-critical workloads, we’ve got a server that fits your purpose.",
        options: ['Consumer', 'SMB', 'Enterprise'],
//        optContext: {
//            'Consumer': 'For personal use',
//            'SMB': 'For business with less than 100 employees', 
//           'Enterprise': 'For large organizations with over 100 employees'
//        },
        icons: {
            'Consumer': '<svg xmlns="http://www.w3.org/2000/svg" height="32px" viewBox="0 -960 960 960" width="32px" fill="#0095ff"><path d="M160-120v-375l-72 55-48-64 120-92v-124h80v63l240-183 440 336-48 63-72-54v375H160Zm80-80h200v-160h80v160h200v-356L480-739 240-556v356Zm-80-560q0-50 35-85t85-35q17 0 28.5-11.5T320-920h80q0 50-35 85t-85 35q-17 0-28.5 11.5T240-760h-80Zm80 560h480-480Z"></path></svg>',
            'SMB' : '<svg xmlns="http://www.w3.org/2000/svg" height="32px" viewBox="0 -960 960 960" width="32px" fill="#0095ff"><path d="M480-340q33 0 56.5-23.5T560-420q0-33-23.5-56.5T480-500q-33 0-56.5 23.5T400-420q0 33 23.5 56.5T480-340ZM160-120q-33 0-56.5-23.5T80-200v-440q0-33 23.5-56.5T160-720h160v-80q0-33 23.5-56.5T400-880h160q33 0 56.5 23.5T640-800v80h160q33 0 56.5 23.5T880-640v440q0 33-23.5 56.5T800-120H160Zm0-80h640v-440H160v440Zm240-520h160v-80H400v80ZM160-200v-440 440Z"></path></svg>',
            'Enterprise': '<svg xmlns="http://www.w3.org/2000/svg" height="32px" viewBox="0 -960 960 960" width="32px" fill="#0095ff"><path d="M120-120v-560h240v-80l120-120 120 120v240h240v400H120Zm80-80h80v-80h-80v80Zm0-160h80v-80h-80v80Zm0-160h80v-80h-80v80Zm240 320h80v-80h-80v80Zm0-160h80v-80h-80v80Zm0-160h80v-80h-80v80Zm0-160h80v-80h-80v80Zm240 480h80v-80h-80v80Zm0-160h80v-80h-80v80Z"></path></svg>'
        },
        type: 'single',
        confirm: false 
    },
    {
        key: 'selected_solution',
        question: 'What are your main uses for this server? ',
        context: "Our Remade in Brooklyn servers are built to perform—whether it’s for data mining, media hosting, or advanced network management. Select all that apply to you.",
        options: ['Backup',	'Gaming', 'Virtualization','Media', 'Data Mining','IT Training','File Hosting','Database', 'Network management', 'Homelab', 'Surveillance', 'Domain Controller', 'NAS', 'Application Hosting'],
        icons: {
            'Backup': '<svg xmlns="http://www.w3.org/2000/svg" width="32px" height="32px" viewBox="0 0 24 24" fill="none"> <path d="M21.96 13.4199C21.8233 12.3214 21.326 11.2993 20.546 10.5139C19.766 9.72844 18.7474 9.22406 17.65 9.07977C17.1768 7.75468 16.2529 6.63824 15.0399 5.92523C13.8269 5.21223 12.4019 4.94801 11.0139 5.17914C9.62597 5.41026 8.36341 6.12202 7.4469 7.18964C6.53039 8.25726 6.01826 9.61302 6 11.02C4.93913 11.02 3.92172 11.4412 3.17157 12.1913C2.42142 12.9415 2 13.9591 2 15.02C2 16.0808 2.42142 17.0982 3.17157 17.8483C3.92172 18.5985 4.93913 19.02 6 19.02H11" stroke="#0095ff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M14 18.6501L16.76 21.6501L22 16.3501" stroke="#0095ff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
            'Gaming':'<svg xmlns="http://www.w3.org/2000/svg" width="32px" height="32px" viewBox="0 0 24 24" fill="none"><path d="M6.00014 11H10.0001M8.00014 9V13M15.0001 12H15.0101M18.0001 10H18.0101M10.4491 5H13.5512C16.1761 5 17.4885 5 18.5187 5.49743C19.4257 5.9354 20.1793 6.63709 20.6808 7.51059C21.2503 8.5027 21.3438 9.81181 21.5309 12.43L21.7769 15.8745C21.8975 17.5634 20.5599 19 18.8667 19C18.0008 19 17.1796 18.6154 16.6253 17.9502L16.2501 17.5C15.907 17.0882 15.7354 16.8823 15.54 16.7159C15.1305 16.3672 14.6346 16.1349 14.1045 16.0436C13.8516 16 13.5836 16 13.0476 16H10.9527C10.4167 16 10.1487 16 9.89577 16.0436C9.36563 16.1349 8.86981 16.3672 8.46024 16.7159C8.26487 16.8823 8.09329 17.0882 7.75013 17.5L7.37497 17.9502C6.82064 18.6154 5.99949 19 5.13359 19C3.44037 19 2.10275 17.5634 2.22339 15.8745L2.46942 12.43C2.65644 9.81181 2.74994 8.5027 3.31951 7.51059C3.82098 6.63709 4.57458 5.9354 5.48159 5.49743C6.51176 5 7.8242 5 10.4491 5Z" stroke="#0095ff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
            'Virtualization':'<svg xmlns="http://www.w3.org/2000/svg" fill="#0095ff" width="32px" height="32px" viewBox="0 0 32 32" id="icon"><defs><style>.cls-1 {fill: none;}</style></defs><path d="M17,13V6H8V22H24V13ZM10,8h5v5H10Zm0,7h5v5H10Zm12,5H17V15h5Z" transform="translate(0 0)"/><path d="M28,11H19V2h9ZM21,9h5V4H21Z" transform="translate(0 0)"/><path d="M28,20H26v2h2v6H4V22H6V20H4a2.0024,2.0024,0,0,0-2,2v6a2.0024,2.0024,0,0,0,2,2H28a2.0024,2.0024,0,0,0,2-2V22A2.0024,2.0024,0,0,0,28,20Z" transform="translate(0 0)"/><circle cx="7" cy="25" r="1"/><rect id="_Transparent_Rectangle_" data-name="&lt;Transparent Rectangle&gt;" class="cls-1" width="32" height="32"/></svg>',
            'Media':'<svg xmlns="http://www.w3.org/2000/svg" width="32px" height="32px" viewBox="0 0 24 24" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M10.295 6.63012C9.29593 6.0057 8 6.72396 8 7.90212V16.0979C8 17.276 9.29592 17.9943 10.295 17.3699L16.8516 13.272C17.7916 12.6845 17.7916 11.3155 16.8516 10.728L10.295 6.63012ZM10 15.1957V8.80424L15.1132 12L10 15.1957Z" fill="#0095ff"/><path fill-rule="evenodd" clip-rule="evenodd" d="M12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1ZM3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12Z" fill="#0095ff"/></svg>',
            'Data Mining':'<svg xmlns="http://www.w3.org/2000/svg" width="32px" height="32px" viewBox="0 0 1024 1024"><path fill="#0095ff" d="M359.168 768H160a32 32 0 0 1-32-32V192H64a32 32 0 0 1 0-64h896a32 32 0 1 1 0 64h-64v544a32 32 0 0 1-32 32H665.216l110.848 192h-73.856L591.36 768H433.024L322.176 960H248.32l110.848-192zM832 192H192v512h640V192zM342.656 534.656a32 32 0 1 1-45.312-45.312L444.992 341.76l125.44 94.08L679.04 300.032a32 32 0 1 1 49.92 39.936L581.632 524.224 451.008 426.24 342.656 534.592z"/></svg>',
            'IT Training':'<svg version="1.1" id="Icons" xmlns="http://www.w3.org/2000/svg" width="32px" height="32px" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 32 32" xml:space="preserve"><style type="text/css">.st0{fill:none;stroke:#0095ff;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}</style><line class="st0" x1="9" y1="29" x2="23" y2="29"/><path class="st0" d="M13,23c0,2.1-0.7,4.6-1.8,6"/><path class="st0" d="M20.8,29c-1.1-1.4-1.8-3.9-1.8-6"/><path class="st0" d="M16,20V10c0-1.7-1.3-3-3-3H7v10h6C14.7,17,16,18.3,16,20L16,20"/><path class="st0" d="M16,20V10c0-1.7,1.3-3,3-3h6v10h-6C17.3,17,16,18.3,16,20L16,20"/><path class="st0" d="M3,6v15c0,1.1,0.9,2,2,2h22c1.1,0,2-0.9,2-2V6c0-1.1-0.9-2-2-2H5C3.9,4,3,4.9,3,6z"/></svg>',
            'File Hosting':'<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#0095ff" version="1.1" id="Capa_1" width="32px" height="32px" viewBox="0 0 98.861 98.861" xml:space="preserve"> <g> <g> <path d="M73.847,30.236H25.016c-1.562,0-2.836,1.263-2.836,2.828v9.628c0,1.565,1.274,2.828,2.836,2.828h48.831    c1.559,0,2.832-1.263,2.832-2.828v-9.628C76.679,31.499,75.404,30.236,73.847,30.236z M27.287,36.942    c-0.965,0-1.747-0.78-1.747-1.746c0-0.963,0.782-1.745,1.747-1.745c0.967,0,1.746,0.782,1.746,1.745    C29.033,36.163,28.254,36.942,27.287,36.942z M69.231,41.976H56.895v-4.097h12.337V41.976z"/> <path d="M73.847,47.075H25.016c-1.562,0-2.836,1.265-2.836,2.83v9.627c0,1.563,1.274,2.829,2.836,2.829h48.831    c1.559,0,2.832-1.266,2.832-2.829v-9.627C76.679,48.34,75.404,47.075,73.847,47.075z M27.287,53.783    c-0.965,0-1.747-0.777-1.747-1.746c0-0.962,0.782-1.748,1.747-1.748c0.967,0,1.746,0.785,1.746,1.748    C29.033,53.005,28.254,53.783,27.287,53.783z M69.231,58.816H56.895v-4.098h12.337V58.816z"/> <path d="M73.847,63.915H25.016c-1.562,0-2.836,1.265-2.836,2.829v9.627c0,1.564,1.274,2.83,2.836,2.83h48.831    c1.559,0,2.832-1.266,2.832-2.83v-9.627C76.679,65.18,75.404,63.915,73.847,63.915z M27.287,70.621    c-0.965,0-1.747-0.775-1.747-1.746c0-0.964,0.782-1.744,1.747-1.744c0.967,0,1.746,0.779,1.746,1.744    C29.033,69.846,28.254,70.621,27.287,70.621z M69.231,75.654H56.895v-4.098h12.337V75.654z"/> <polygon points="57.864,88.409 52.66,88.409 52.66,80.838 46.204,80.838 46.204,88.409 40.994,88.409 40.994,90.404     22.778,90.404 22.778,96.863 40.994,96.863 40.994,98.861 57.864,98.861 57.864,96.863 76.079,96.863 76.079,90.404     57.864,90.404   "/> <path d="M78.253,14.706c-0.699-0.059-1.341-0.416-1.757-0.979C72.581,8.44,66.304,5.179,59.624,5.179    c-0.418,0-0.837,0.013-1.256,0.038c-0.58,0.035-1.15-0.138-1.613-0.488C52.688,1.662,47.76,0,42.602,0    C33.36,0,25.157,5.354,21.323,13.461c-0.352,0.743-1.054,1.259-1.868,1.373C9.269,16.267,1.405,25.039,1.405,35.613    c0,10.081,7.147,18.519,16.641,20.526v-6.234c0-0.777,0.144-1.518,0.383-2.215c-5.077-1.669-8.757-6.448-8.757-12.076    c0-7.011,5.704-12.715,12.716-12.715c0.354,0,0.702,0.028,1.049,0.056c2.021,0.157,3.849-1.154,4.342-3.114    c1.709-6.814,7.806-11.573,14.822-11.573c4.01,0,7.805,1.548,10.685,4.36c0.984,0.96,2.383,1.369,3.729,1.088    c0.859-0.179,1.736-0.27,2.609-0.27c4.909,0,9.293,2.76,11.44,7.202c0.755,1.562,2.405,2.492,4.132,2.314    c0.43-0.043,0.859-0.064,1.275-0.064c7.012,0,12.717,5.704,12.717,12.715c0,5.629-3.682,10.407-8.758,12.076    c0.238,0.698,0.382,1.438,0.382,2.215v6.233c9.493-2.006,16.644-10.443,16.644-20.525C97.455,24.643,88.991,15.612,78.253,14.706z    "/> </g> </g> </svg>',
            'Database':'<svg xmlns="http://www.w3.org/2000/svg" width="32px" height="32px" viewBox="0 0 24 24" fill="none"> <path d="M21 5C21 6.65685 16.9706 8 12 8C7.02944 8 3 6.65685 3 5M21 5C21 3.34315 16.9706 2 12 2C7.02944 2 3 3.34315 3 5M21 5V19C21 20.66 17 22 12 22C7 22 3 20.66 3 19V5M21 12C21 13.66 17 15 12 15C7 15 3 13.66 3 12" stroke="#0095ff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/> </svg>',
            'Website Hosting':'<svg xmlns="http://www.w3.org/2000/svg" width="32px" height="32px" viewBox="0 0 64 64" stroke-width="3" stroke="#0095ff" fill="none"><path d="M39.93,55.72A24.86,24.86,0,1,1,56.86,32.15a37.24,37.24,0,0,1-.73,6"/><path d="M37.86,51.1A47,47,0,0,1,32,56.7"/><path d="M32,7A34.14,34.14,0,0,1,43.57,30a34.07,34.07,0,0,1,.09,4.85"/><path d="M32,7A34.09,34.09,0,0,0,20.31,32.46c0,16.2,7.28,21,11.66,24.24"/><line x1="10.37" y1="19.9" x2="53.75" y2="19.9"/><line x1="32" y1="6.99" x2="32" y2="56.7"/><line x1="11.05" y1="45.48" x2="37.04" y2="45.48"/><line x1="7.14" y1="32.46" x2="56.86" y2="31.85"/><path d="M53.57,57,58,52.56l-8-8,4.55-2.91a.38.38,0,0,0-.12-.7L39.14,37.37a.39.39,0,0,0-.46.46L42,53.41a.39.39,0,0,0,.71.13L45.57,49Z"/></svg>',
            'Network management':'<svg xmlns="http://www.w3.org/2000/svg" width="32px" height="32px" viewBox="0 0 24 24" fill="none"> <path d="M3 12H21M12 8V12M6.5 12V16M17.5 12V16M10.1 8H13.9C14.4601 8 14.7401 8 14.954 7.89101C15.1422 7.79513 15.2951 7.64215 15.391 7.45399C15.5 7.24008 15.5 6.96005 15.5 6.4V4.6C15.5 4.03995 15.5 3.75992 15.391 3.54601C15.2951 3.35785 15.1422 3.20487 14.954 3.10899C14.7401 3 14.4601 3 13.9 3H10.1C9.53995 3 9.25992 3 9.04601 3.10899C8.85785 3.20487 8.70487 3.35785 8.60899 3.54601C8.5 3.75992 8.5 4.03995 8.5 4.6V6.4C8.5 6.96005 8.5 7.24008 8.60899 7.45399C8.70487 7.64215 8.85785 7.79513 9.04601 7.89101C9.25992 8 9.53995 8 10.1 8ZM15.6 21H19.4C19.9601 21 20.2401 21 20.454 20.891C20.6422 20.7951 20.7951 20.6422 20.891 20.454C21 20.2401 21 19.9601 21 19.4V17.6C21 17.0399 21 16.7599 20.891 16.546C20.7951 16.3578 20.6422 16.2049 20.454 16.109C20.2401 16 19.9601 16 19.4 16H15.6C15.0399 16 14.7599 16 14.546 16.109C14.3578 16.2049 14.2049 16.3578 14.109 16.546C14 16.7599 14 17.0399 14 17.6V19.4C14 19.9601 14 20.2401 14.109 20.454C14.2049 20.6422 14.3578 20.7951 14.546 20.891C14.7599 21 15.0399 21 15.6 21ZM4.6 21H8.4C8.96005 21 9.24008 21 9.45399 20.891C9.64215 20.7951 9.79513 20.6422 9.89101 20.454C10 20.2401 10 19.9601 10 19.4V17.6C10 17.0399 10 16.7599 9.89101 16.546C9.79513 16.3578 9.64215 16.2049 9.45399 16.109C9.24008 16 8.96005 16 8.4 16H4.6C4.03995 16 3.75992 16 3.54601 16.109C3.35785 16.2049 3.20487 16.3578 3.10899 16.546C3 16.7599 3 17.0399 3 17.6V19.4C3 19.9601 3 20.2401 3.10899 20.454C3.20487 20.6422 3.35785 20.7951 3.54601 20.891C3.75992 21 4.03995 21 4.6 21Z" stroke="#0095ff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/> </svg>',
            'Homelab':'<svg xmlns="http://www.w3.org/2000/svg" fill="#0095ff" width="32px" height="32px" viewBox="0 0 24 24"><path d="M22,21H21V14a3,3,0,0,0-3-3H14.172V8.945a4.987,4.987,0,0,0,6.363-.581,1,1,0,0,0,0-1.414L14.879,1.293a1,1,0,0,0-1.414,0A4.968,4.968,0,0,0,12,4.828a4.985,4.985,0,0,0,.172,1.234V11H8V8.816a3,3,0,1,0-2,0V11a3,3,0,0,0-3,3v7H2a1,1,0,0,0,0,2H22a1,1,0,0,0,0-2ZM14.292,3.534l4,4a3.066,3.066,0,0,1-3.415-.587,3.005,3.005,0,0,1-.587-3.416ZM7,5A1,1,0,1,1,6,6,1,1,0,0,1,7,5Zm5,16H9V19a1.5,1.5,0,0,1,3,0Zm7-6H16a1,1,0,0,0,0,2h3v4H14V19a3.5,3.5,0,0,0-7,0v2H5V14a1,1,0,0,1,1-1H18a1,1,0,0,1,1,1Z"/></svg>',
            'Surveillance':'<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="32px" height="32px" viewBox="0 0 512 512" version="1.1"> <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"> <g id="drop" fill="#0095ff" transform="translate(64.000000, 105.788405)"> <path d="M44.1717837,-7.10542736e-14 L405.011659,98.4449647 L370.689,132.808 L394.489897,139.214538 L372.404005,221.640208 L301.059,202.523 L265.797494,237.829776 L177.65,213.627 L128.051615,299.534806 L128,299.510221 L128,299.544928 L42.6666667,299.531555 L42.6666667,342.211595 L3.62376795e-12,342.211595 L3.62376795e-12,214.211595 L42.6666667,214.211595 L42.6666667,256.864888 L103.402667,256.864888 L135.118,201.949 L3.12638804e-13,164.851341 L44.1717837,-7.10542736e-14 Z M74.286534,52.4390133 L52.1840777,134.926503 L253.136277,190.096636 L322.893293,120.245632 L74.286534,52.4390133 Z" id="Combined-Shape"> </path> </g> </g> </svg>',
            'Domain Controller':'<svg xmlns="http://www.w3.org/2000/svg" width="32px" height="32px" viewBox="0 0 24 24" fill="none"> <path d="M14 20C14 21.1046 13.1046 22 12 22C10.8954 22 10 21.1046 10 20M14 20C14 18.8954 13.1046 18 12 18M14 20H21M10 20C10 18.8954 10.8954 18 12 18M10 20H3M12 18V14M21 5C21 6.65685 16.9706 8 12 8C7.02944 8 3 6.65685 3 5M21 5C21 3.34315 16.9706 2 12 2C7.02944 2 3 3.34315 3 5M21 5V11C21 12.66 17 14 12 14M3 5V11C3 12.66 7 14 12 14" stroke="#0095ff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/> </svg>',
            'NAS': '<svg xmlns="http://www.w3.org/2000/svg" height="32px" viewBox="0 -960 960 960" width="32px" fill="#0095ff"><path d="M457-430h181q24.32 0 41.16-16.77 16.84-16.78 16.84-41 0-24.23-16.84-41.73Q662.32-547 638-547h-12l-2-10q-4-31-27.78-52-23.77-21-56.46-21Q514-630 492-617q-22 13-30 36l-2 7h-8q-29 0-48.5 21.5T384-502.14q0 28.85 21.5 50.5Q427-430 457-430ZM100-120q-24 0-42-18t-18-42v-570h60v570h730v60H100Zm120-120q-24 0-42-18t-18-42v-520q0-24 18-42t42-18h260l60 60h320q24 0 42 18t18 42v460q0 24-18 42t-42 18H220Zm0-60h640v-460H515l-60-60H220v520Zm0 0v-520 520Z"/></svg>',
            'Application Hosting': '<svg xmlns="http://www.w3.org/2000/svg" height="32px" viewBox="0 -960 960 960" width="32px" fill="#0095ff"><path d="M140-120q-24 0-42-18t-18-42v-600q0-24 18-42t42-18h240q24 0 42 18t18 42v600q0 24-18 42t-42 18H140Zm440 0q-24 0-42-18t-18-42v-600q0-24 18-42t42-18h240q24 0 42 18t18 42v600q0 24-18 42t-42 18H580Zm-440-60h240v-600H140v600Zm440 0h240v-600H580v600ZM200-367h120v-60H200v60Zm440 0h120v-60H640v60ZM200-491h120v-60H200v60Zm440 0h120v-60H640v60ZM200-615h120v-60H200v60Zm440 0h120v-60H640v60ZM140-180h240-240Zm440 0h240-240Z"/></svg>',
            'Gaming':'<svg xmlns="http://www.w3.org/2000/svg" height="40px" viewBox="0 -960 960 960" width="40px" fill="#0095ff"><path d="M158.67-200q-42.34 0-66-28.83Q69-257.67 75.33-304.67l46-323.33q8.34-55.33 50.84-93.67Q214.67-760 270-760h420.67q55.33 0 97.83 38.33Q831-683.33 839.33-628l45.34 323.33q6.33 47-17.34 75.84-23.66 28.83-66 28.83-22.33 0-39-7.5-16.66-7.5-29-19.83L634-326.67H326l-99.33 99.34q-12.34 12.33-29 19.83-16.67 7.5-39 7.5ZM176-271.33l122-122h364l122 122q4 4 17.33 8 9.67 0 14.84-8.17 5.16-8.17 3.16-17.83L772.67-618q-4.67-33-28.34-54.17-23.66-21.16-53.66-21.16H269.33q-30 0-53.66 21.16Q192-651 187.33-618l-46.66 328.67q-2 9.66 3.16 17.83 5.17 8.17 14.84 8.17 5.33 0 17.33-8ZM693.33-440q16.34 0 28.17-11.83 11.83-11.84 11.83-28.17 0-16.33-11.83-28.17Q709.67-520 693.33-520q-16.33 0-28.16 11.83-11.84 11.84-11.84 28.17 0 16.33 11.84 28.17Q677-440 693.33-440ZM610-566.67q16.33 0 28.17-11.83Q650-590.33 650-606.67q0-16.33-11.83-28.16-11.84-11.84-28.17-11.84-16.33 0-28.17 11.84Q570-623 570-606.67q0 16.34 11.83 28.17 11.84 11.83 28.17 11.83ZM303.33-443.33h53.34v-73.34H430V-570h-73.33v-73.33h-53.34V-570H230v53.33h73.33v73.34ZM480-478.67Z"/></svg>',
            'Data Science': '<svg xmlns="http://www.w3.org/2000/svg" height="40px" viewBox="0 -960 960 960" width="40px" fill="#0095ff"><path d="M181.33-120q-44.85 0-63.76-41.17-18.9-41.16 11.1-75.5L368-513.33v-260h-48q-14.17 0-23.75-9.62t-9.58-23.83q0-14.22 9.58-23.72 9.58-9.5 23.75-9.5h320q14.17 0 23.75 9.62 9.58 9.61 9.58 23.83 0 14.22-9.58 23.72-9.58 9.5-23.75 9.5h-48v260l239.33 276.66q30 34.34 11.1 75.5Q823.52-120 778.67-120H181.33Zm73.34-100h450.66l-152-176.67H406.67L254.67-220Zm-81.34 33.33h613.34L525.33-489.33v-284h-90.66v284L173.33-186.67ZM480-480Z"/></svg>',
            'Development and Testing': '<svg xmlns="http://www.w3.org/2000/svg" height="40px" viewBox="0 -960 960 960" width="40px" fill="#0095ff"><path d="M153.33-120q-27 0-46.83-19.83-19.83-19.84-19.83-46.84v-586.66q0-27 19.83-46.84Q126.33-840 153.33-840H740q27 0 46.83 19.83 19.84 19.84 19.84 46.84v66.66h66.66V-640h-66.66v126.67h66.66v66.66h-66.66V-320h66.66v66.67h-66.66v66.66q0 27-19.84 46.84Q767-120 740-120H153.33Zm0-66.67H740v-586.66H153.33v586.66ZM220-253.33h235.33V-440H220v186.67Zm268.67-317.34h184.66v-136H488.67v136ZM220-473.33h235.33v-233.34H220v233.34Zm268.67 220h184.66v-284H488.67v284Zm-335.34-520v586.66-586.66Z"/></svg>',
            'IoT Device Management': '<svg xmlns="http://www.w3.org/2000/svg" height="40px" viewBox="0 -960 960 960" width="40px" fill="#0095ff"><path d="M198-278q-57-57-87.5-129.5T80-560q0-80 30.5-152.5T198-842l39.33 39.33q-48.33 49-74.83 111.5T136-560q0 68.67 26.5 131.17 26.5 62.5 74.83 111.5L198-278Zm92-92q-38-38-58-87t-20-103q0-54 20-103t58-87l39.33 39.33q-29.66 30.34-45.5 69.17Q268-602.67 268-560t15.83 81.17q15.84 38.5 45.5 69.5L290-370Zm156.67 250v-352Q419-482 402.5-506.33 386-530.67 386-560q0-39.33 27.33-66.67Q440.67-654 480-654t66.67 27.33Q574-599.33 574-560q0 29.33-16.5 53.67Q541-482 513.33-472v352h-66.66ZM670-370l-39.33-39.33q29.66-31 45.5-69.5Q692-517.33 692-560t-15.83-81.17q-15.84-38.5-45.5-69.5L670-750q38 38 58 87t20 103q0 54-20 103t-58 87Zm92 92-39.33-39.33q48.33-49 74.83-111.5T824-560q0-68.67-26.5-131.17-26.5-62.5-74.83-111.5L762-842q57 57 87.5 129.5T880-560q0 80-30.5 152.5T762-278Z"/></svg>',
            'Video Streaming': '<svg xmlns="http://www.w3.org/2000/svg" height="40px" viewBox="0 -960 960 960" width="40px" fill="#0095ff"><path d="M382-306.67 653.33-480 382-653.33v346.66ZM480-80q-82.33 0-155.33-31.5-73-31.5-127.34-85.83Q143-251.67 111.5-324.67T80-480q0-83 31.5-156t85.83-127q54.34-54 127.34-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 82.33-31.5 155.33-31.5 73-85.5 127.34Q709-143 636-111.5T480-80Zm0-66.67q139.33 0 236.33-97.33t97-236q0-139.33-97-236.33t-236.33-97q-138.67 0-236 97-97.33 97-97.33 236.33 0 138.67 97.33 236 97.33 97.33 236 97.33ZM480-480Z"/></svg>',
            'AI and Machine Learning' :'<svg xmlns="http://www.w3.org/2000/svg" height="40px" viewBox="0 -960 960 960" width="40px" fill="#0095ff"><path d="M305.67-160q-9 0-16.84-4.5Q281-169 276.67-177l-82-146.33h66.66l41.34 80h90.66v-33.34h-70.66l-41.34-80H176.67l-61-106.66q-2-4.34-3.17-8.34t-1.17-8.33q0-2.67 4.34-16.67l61-106.66h104.66l41.34-80h70.66v-33.34h-90.66l-41.34 80h-66.66l82-146.33q4.33-8 12.16-12.5 7.84-4.5 16.84-4.5h111q14.33 0 23.83 9.5 9.5 9.5 9.5 23.83v170h-76.67L340-563.33h110v126.66h-94.67l-39.33-80h-96l-33.33 33.34h108l40 80H450v210q0 14.33-9.5 23.83-9.5 9.5-23.83 9.5h-111Zm261 0q-30.34 0-51.84-21.5-21.5-21.5-21.5-51.83 0-21.67 11-38.84 11-17.16 29-26.16v-363.34q-18-9-29-26.16-11-17.17-11-38.84 0-30.33 21.5-51.83t51.84-21.5q30.33 0 51.83 21.5t21.5 51.83q0 21.67-11 38.84-11 17.16-29 26.16V-552l93.33-56q-2-32 19.84-55.33 21.83-23.34 53.5-23.34 30.33 0 51.83 21.5t21.5 51.84q0 30.33-21.5 51.83T766.67-540q-11 0-20.84-2.83-9.83-2.84-18.16-7.84L625.33-489l111 88.67q7-3 14.67-4.67t15.67-1.67q30.33 0 51.83 21.5t21.5 51.84q0 30.33-21.5 51.83T766.67-260q-35.67 0-57.17-27.33Q688-314.67 695-348l-95-76.33v127q17.33 9 28.17 25.83Q639-254.67 639-233.33q0 30.33-21 51.83T566.67-160Z"/></svg>',
        },
        type: 'multiple',
        confirm: false
    },
    {
        key: 'selected_emphasis',
        question: 'What features are most important to you?:',
        context: 'Select all that apply.',
        options: ['Performance', 'Memory', 'Storage', 'Network Connectivity', 'Energy Efficient', 'Noise Level', 'Affordable', 'NVMe', 'GPU', 'Perfect Starter Server'],
        icons: {
            'Performance':'<svg xmlns="http://www.w3.org/2000/svg" fill="#0095ff" width="32px" height="32px" viewBox="0 0 16 16"><path d="M2.67 10.73a3.52 3.52 0 0 0-.94 1.93 5 5 0 0 0-.07 1.1v.58h.8a5.05 5.05 0 0 0 .88-.08 3.46 3.46 0 0 0 1.93-.94 1.76 1.76 0 0 0-.14-2.48 1.76 1.76 0 0 0-2.46-.11zm1.74 1.73a2.26 2.26 0 0 1-1.26.6h-.22v-.22a2.26 2.26 0 0 1 .6-1.26.36.36 0 0 1 .24-.08.67.67 0 0 1 .47.22.54.54 0 0 1 .17.74zM14.65 2.24a.91.91 0 0 0-.89-.89A8.75 8.75 0 0 0 7.27 3.5L5.64 5.4l-2.4-.5a1 1 0 0 0-.92.27l-.68.68a1 1 0 0 0-.28.81 1 1 0 0 0 .45.74l2.06 1.32.13.08 3.2 3.25.08.08 1.32 2.06a1 1 0 0 0 .74.45h.11a1 1 0 0 0 .7-.29l.68-.68a1 1 0 0 0 .27-.92l-.5-2.39 1.84-1.58a8.79 8.79 0 0 0 2.21-6.54zM3.11 6.15l1.32.28-.64.75-1-.67zm6.38 7.1-.67-1 .75-.64.28 1.32zm2.39-5.11.18.17zm-.28-.28L7.92 11 5 8.08 8.14 4.4a7.44 7.44 0 0 1 5.26-1.8 7.48 7.48 0 0 1-1.8 5.26z"/><path d="M11.13 6.63a1.19 1.19 0 0 0-.06-1.7 1.16 1.16 0 1 0-1.64 1.63 1.2 1.2 0 0 0 1.7.07z"/></svg>',
            'Memory':'<svg xmlns="http://www.w3.org/2000/svg" width="32px" height="32px" viewBox="0 0 24 24" id="Layer_1" data-name="Layer 1"><defs><style>.cls-1{fill:none;stroke:#0095ff;stroke-miterlimit:10;stroke-width:1.91px;}</style></defs><path class="cls-1" d="M21.55,11.05a1,1,0,0,0,.95.95v6.68H1.5V12a1,1,0,0,0,0-1.91V5.32h21v4.77A1,1,0,0,0,21.55,11.05Z"/><rect class="cls-1" x="6.27" y="9.14" width="5.73" height="3.82"/><rect class="cls-1" x="12" y="9.14" width="5.73" height="3.82"/><line class="cls-1" x1="4.36" y1="15.82" x2="4.36" y2="18.68"/><line class="cls-1" x1="8.18" y1="15.82" x2="8.18" y2="18.68"/><line class="cls-1" x1="12" y1="15.82" x2="12" y2="18.68"/><line class="cls-1" x1="15.82" y1="15.82" x2="15.82" y2="18.68"/><line class="cls-1" x1="19.64" y1="15.82" x2="19.64" y2="18.68"/></svg>',
            'Storage':'<svg xmlns="http://www.w3.org/2000/svg" width="32px" height="32px" viewBox="0 0 512 512"> <path fill="var(--ci-primary-color, #0095ff)" d="M16,48V464H496V48ZM464,432H48V336H464Zm0-128H48V208H464ZM48,176V80H464v96Z" class="ci-primary"/> <rect width="32" height="32" x="80" y="112" fill="var(--ci-primary-color, #0095ff)" class="ci-primary"/> <rect width="32" height="32" x="80" y="240" fill="var(--ci-primary-color, #0095ff)" class="ci-primary"/> <rect width="32" height="32" x="80" y="368" fill="var(--ci-primary-color, #0095ff)" class="ci-primary"/> </svg>',
            'Network Connectivity':'<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#0095ff" height="32px" width="32px" version="1.1" id="XMLID_127_" viewBox="0 0 24 24" xml:space="preserve"> <g id="connect"> <g> <path d="M5.9,24c-1.6,0-3.1-0.6-4.2-1.7C0.6,21.2,0,19.7,0,18.1c0-1.6,0.6-3.1,1.7-4.2l3.8-3.8l2,2l2.8-2.8l1.4,1.4l-2.8,2.8    l1.6,1.6l2.8-2.8l1.4,1.4l-2.8,2.8l2,2l-3.7,3.8C9,23.3,7.5,24,5.9,24z M5.5,12.9l-2.3,2.3C2.4,16,2,17,2,18s0.4,2,1.2,2.8    c1.5,1.5,4.1,1.5,5.6,0l2.3-2.4L5.5,12.9z M18.5,13.9l-8.4-8.4l3.7-3.8C14.9,0.6,16.5,0,18,0c1.5,0,3,0.6,4.2,1.7    C23.4,2.8,24,4.3,24,5.9s-0.6,3.1-1.7,4.2L18.5,13.9z M13,5.5l5.5,5.5l2.3-2.3C21.6,7.9,22,7,22,5.9c0-1-0.4-2-1.2-2.8    c-1.5-1.5-4-1.5-5.6,0L13,5.5z"/> </g> </g> </svg>',
            'Energy Efficient':'<svg xmlns="http://www.w3.org/2000/svg" width="32px" height="32px" viewBox="0 0 24 24" id="Layer_1" data-name="Layer 1"><defs><style>.cls-1{fill:none;stroke:#0095ff;stroke-miterlimit:10;stroke-width:1.91px;}</style></defs><path class="cls-1" d="M15.82,1.5h1.91a0,0,0,0,1,0,0V7.23a0,0,0,0,1,0,0H15.82a1.91,1.91,0,0,1-1.91-1.91V3.41A1.91,1.91,0,0,1,15.82,1.5Z"/><line class="cls-1" x1="21.55" y1="2.45" x2="17.73" y2="2.45"/><line class="cls-1" x1="21.55" y1="6.27" x2="17.73" y2="6.27"/><path class="cls-1" d="M20.59,13.43a9.07,9.07,0,1,1-9.07-9.07h2.39"/><path class="cls-1" d="M7.23,10.09H9.68a4.23,4.23,0,0,1,4.23,4.23v2.46a0,0,0,0,1,0,0H11.45a4.23,4.23,0,0,1-4.23-4.23V10.09A0,0,0,0,1,7.23,10.09Z"/><line class="cls-1" x1="15.82" y1="18.68" x2="10.09" y2="12.95"/></svg>',
            'Noise Level':'<svg xmlns="http://www.w3.org/2000/svg" width="32px" height="32px" viewBox="0 0 24 24" fill="none"> <path d="M3 11V13M6 8V16M9 10V14M12 7V17M15 4V20M18 9V15M21 11V13" stroke="#0095ff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg>',
            'Affordable':'<svg xmlns="http://www.w3.org/2000/svg" width="32px" height="32px" viewBox="-0.5 0 25 25" fill="none"> <path d="M12.8702 16.97V18.0701C12.8702 18.2478 12.7995 18.4181 12.6739 18.5437C12.5482 18.6694 12.3778 18.74 12.2001 18.74C12.0224 18.74 11.852 18.6694 11.7264 18.5437C11.6007 18.4181 11.5302 18.2478 11.5302 18.0701V16.9399C11.0867 16.8668 10.6625 16.7051 10.2828 16.4646C9.90316 16.2241 9.57575 15.9097 9.32013 15.54C9.21763 15.428 9.16061 15.2817 9.16016 15.1299C9.16006 15.0433 9.17753 14.9576 9.21155 14.8779C9.24557 14.7983 9.29545 14.7263 9.35809 14.6665C9.42074 14.6067 9.49484 14.5601 9.57599 14.5298C9.65713 14.4994 9.7436 14.4859 9.83014 14.49C9.91602 14.4895 10.0009 14.5081 10.0787 14.5444C10.1566 14.5807 10.2254 14.6338 10.2802 14.7C10.6 15.1178 11.0342 15.4338 11.5302 15.6099V13.0701C10.2002 12.5401 9.53015 11.77 9.53015 10.76C9.55019 10.2193 9.7627 9.70353 10.1294 9.30566C10.4961 8.9078 10.9929 8.65407 11.5302 8.59009V7.47998C11.5302 7.30229 11.6007 7.13175 11.7264 7.0061C11.852 6.88045 12.0224 6.81006 12.2001 6.81006C12.3778 6.81006 12.5482 6.88045 12.6739 7.0061C12.7995 7.13175 12.8702 7.30229 12.8702 7.47998V8.58008C13.2439 8.63767 13.6021 8.76992 13.9234 8.96924C14.2447 9.16856 14.5226 9.43077 14.7402 9.73999C14.8284 9.85568 14.8805 9.99471 14.8901 10.1399C14.8928 10.2256 14.8783 10.3111 14.8473 10.3911C14.8163 10.4711 14.7696 10.5439 14.7099 10.6055C14.6502 10.667 14.5787 10.7161 14.4998 10.7495C14.4208 10.7829 14.3359 10.8001 14.2501 10.8C14.1607 10.7989 14.0725 10.7787 13.9915 10.7407C13.9104 10.7028 13.8384 10.648 13.7802 10.5801C13.5417 10.2822 13.2274 10.054 12.8702 9.91992V12.1699L13.1202 12.27C14.3902 12.76 15.1802 13.4799 15.1802 14.6299C15.163 15.2399 14.9149 15.8208 14.4862 16.2551C14.0575 16.6894 13.4799 16.9449 12.8702 16.97ZM11.5302 11.5901V9.96997C11.3688 10.0285 11.2298 10.1363 11.1329 10.2781C11.0361 10.4198 10.9862 10.5884 10.9902 10.76C10.9984 10.93 11.053 11.0945 11.1483 11.2356C11.2435 11.3767 11.3756 11.4889 11.5302 11.5601V11.5901ZM13.7302 14.6599C13.7302 14.1699 13.3902 13.8799 12.8702 13.6599V15.6599C13.1157 15.6254 13.3396 15.5009 13.4985 15.3105C13.6574 15.1202 13.74 14.8776 13.7302 14.6299V14.6599Z" fill="#0095ff"/> <path d="M12.58 3.96997H6C4.93913 3.96997 3.92178 4.39146 3.17163 5.1416C2.42149 5.89175 2 6.9091 2 7.96997V17.97C2 19.0308 2.42149 20.0482 3.17163 20.7983C3.92178 21.5485 4.93913 21.97 6 21.97H18C19.0609 21.97 20.0783 21.5485 20.8284 20.7983C21.5786 20.0482 22 19.0308 22 17.97V11.8999" stroke="#0095ff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M21.9998 2.91992L16.3398 8.57992" stroke="#0095ff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M20.8698 8.5798H16.3398V4.0498" stroke="#0095ff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg>',
            'NVMe':'<svg xmlns="http://www.w3.org/2000/svg" fill="#0095ff" width="32px" height="32px" viewBox="0 0 16 16"><path d="M9.32 15.653a.812.812 0 0 1-.086-.855c.176-.342.245-.733.2-1.118a2.106 2.106 0 0 0-.267-.779 2.027 2.027 0 0 0-.541-.606 3.96 3.96 0 0 1-1.481-2.282c-1.708 2.239-1.053 3.51-.235 4.63a.748.748 0 0 1-.014.901.87.87 0 0 1-.394.283.838.838 0 0 1-.478.023c-1.105-.27-2.145-.784-2.85-1.603a4.686 4.686 0 0 1-.906-1.555 4.811 4.811 0 0 1-.263-1.797s-.133-2.463 2.837-4.876c0 0 3.51-2.978 2.292-5.18a.621.621 0 0 1 .112-.653.558.558 0 0 1 .623-.147l.146.058a7.63 7.63 0 0 1 2.96 3.5c.58 1.413.576 3.06.184 4.527.325-.292.596-.641.801-1.033l.029-.064c.198-.477.821-.325 1.055-.013.086.137 2.292 3.343 1.107 6.048a5.516 5.516 0 0 1-1.84 2.027 6.127 6.127 0 0 1-2.138.893.834.834 0 0 1-.472-.038.867.867 0 0 1-.381-.29zM7.554 7.892a.422.422 0 0 1 .55.146c.04.059.066.126.075.198l.045.349c.02.511.014 1.045.213 1.536.206.504.526.95.932 1.298a3.06 3.06 0 0 1 1.16 1.422c.22.564.25 1.19.084 1.773a4.123 4.123 0 0 0 1.39-.757l.103-.084c.336-.277.613-.623.813-1.017.201-.393.322-.825.354-1.269.065-1.025-.284-2.054-.827-2.972-.248.36-.59.639-.985.804-.247.105-.509.17-.776.19a.792.792 0 0 1-.439-.1.832.832 0 0 1-.321-.328.825.825 0 0 1-.035-.729c.412-.972.54-2.05.365-3.097a5.874 5.874 0 0 0-1.642-3.16c-.156 2.205-2.417 4.258-2.881 4.7a3.537 3.537 0 0 1-.224.194c-2.426 1.965-2.26 3.755-2.26 3.834a3.678 3.678 0 0 0 .459 2.043c.365.645.89 1.177 1.52 1.54C4.5 12.808 4.5 10.89 7.183 8.14l.372-.25z"/></svg>',
            'GPU':'<svg xmlns="http://www.w3.org/2000/svg" width="32px" height="32px" viewBox="0 0 32 32"><path d="M12.447,12.265V10.591c.163-.012.327-.02.494-.026,4.577-.143,7.581,3.934,7.581,3.934S17.278,19,13.8,19a4.2,4.2,0,0,1-1.353-.217V13.712c1.782.215,2.14,1,3.212,2.788l2.383-2.009A6.312,6.312,0,0,0,13.37,12.21a8.606,8.606,0,0,0-.923.055m0-5.529v2.5c.164-.013.329-.024.494-.03,6.366-.214,10.513,5.221,10.513,5.221s-4.764,5.792-9.726,5.792a7.4,7.4,0,0,1-1.281-.112v1.545a8.528,8.528,0,0,0,1.067.069c4.618,0,7.958-2.358,11.192-5.15.535.43,2.731,1.474,3.182,1.932-3.075,2.574-10.241,4.649-14.3,4.649-.392,0-.769-.024-1.138-.06v2.172H30V6.736Zm0,12.051v1.32c-4.271-.762-5.457-5.2-5.457-5.2a9.234,9.234,0,0,1,5.457-2.64v1.447h-.006a4.1,4.1,0,0,0-3.184,1.456s.782,2.811,3.19,3.62M4.861,14.713a10.576,10.576,0,0,1,7.586-4.122V9.236C6.848,9.685,2,14.427,2,14.427s2.746,7.939,10.447,8.665v-1.44C6.8,20.941,4.861,14.713,4.861,14.713Z" style="fill: #0095ff;"/></svg>',
            'Perfect Starter Server':'<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#0095ff" version="1.1" id="Capa_1" width="32px" height="32px" viewBox="0 0 897.5 897.5" xml:space="preserve"> <g> <g> <path d="M30.48,50v797.5c0,27.6,22.4,50,50,50h140.7c27.6,0,50-22.4,50-50V50c0-27.6-22.4-50-50-50H80.48    C52.88,0,30.48,22.4,30.48,50z M226.98,798.399c0,11-9,20-20,20H94.68c-11,0-20-9-20-20v-3.8c0-11,9-20,20-20h112.3    c11,0,20,9,20,20V798.399z M226.98,230c0,11-9,20-20,20H94.68c-11,0-20-9-20-20v-3.8c0-11,9-20,20-20h112.3c11,0,20,9,20,20V230z     M94.68,90.3h112.3c11,0,20,9,20,20v3.8c0,11-9,20-20,20H94.68c-11,0-20-9-20-20v-3.8C74.68,99.3,83.68,90.3,94.68,90.3z"/> <path d="M556.88,34.4c-10.601-25.5-39.9-37.6-65.4-27l-129.9,54c-25.5,10.6-37.6,39.9-27,65.4L640.88,863.1    c10.6,25.5,39.899,37.601,65.399,27l129.9-54c25.5-10.6,37.6-39.899,27-65.399L556.88,34.4z M400.08,169.1l-1.5-3.5    c-4.199-10.2,0.601-21.9,10.801-26.1l103.8-43.2c10.2-4.2,21.899,0.6,26.1,10.8l1.5,3.5c4.2,10.2-0.6,21.9-10.8,26.1l-103.7,43.1    C416.08,184.1,404.38,179.3,400.08,169.1z M574.48,243.7l-103.7,43.1c-10.2,4.2-21.899-0.6-26.1-10.8l-1.5-3.5    c-4.2-10.2,0.6-21.9,10.8-26.1l103.7-43.1c10.2-4.2,21.899,0.6,26.1,10.8l1.5,3.5C589.48,227.7,584.68,239.4,574.48,243.7z     M792.78,768.399L689.08,811.5c-10.199,4.2-21.899-0.601-26.1-10.8l-1.5-3.5c-4.2-10.2,0.6-21.9,10.8-26.101l103.7-43.1    c10.2-4.2,21.9,0.6,26.1,10.8l1.5,3.5C807.78,752.5,802.98,764.2,792.78,768.399z"/> </g> </g> </svg>'
        },
        type: 'multiple',
        confirm: true
    }
];



const funFacts = [
    "Did you know? The first computer virus was created in 1983!",
    "Fun Fact: The world's first website is still online!",
    "Interesting: More than 500 hours of video are uploaded to YouTube every minute.",
    "Did you know? Over 90% of the world's data was created in the last two years.",
    "The concept of virtualization dates back to the 1960s, when IBM developed it to allow large mainframe computers to run multiple applications and test different software environments simultaneously.",
    "Fun Fact: The first computer mouse was invented by Douglas Engelbart in around 1964 and was made of wood!",
    "Did you know? Ada Lovelace's, the first computer programmer, 1843 notes on the Analytical Engine included the first idea of 'looping,' a concept that is a fundamental part of programming over a century later."
];

const loadingList = [
    "Almost there...",
    "Finding the best processor and RAM combo...",
    "High quality servers incoming...",
    "Trying out some new harddrives..."
];




function createSolutionCard(option, icon) {
    const card = document.createElement('div');
    card.classList.add('mikes-pick-container', 'flCol');
    card.id = `mikes-pick-container-${option}`;

    const title = document.createElement('div');
    title.classList.add('mikes-pick-title');
    title.innerHTML = icon + ' ' + option;
    card.appendChild(title);


    const configureButton = document.createElement('div');
    configureButton.classList.add('mcc-configure-button');
    configureButton.id = `configure-${option}`;
    configureButton.innerHTML = `<svg class="md-chass-configure-icon" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#fff">
                        <path d="M480-320q75 0 127.5-52.5T660-500q0-75-52.5-127.5T480-680q-75 0-127.5 52.5T300-500q0 75 52.5 127.5T480-320Zm0-72q-45 0-76.5-31.5T372-500q0-45 31.5-76.5T480-608q45 0 76.5 31.5T588-500q0 45-31.5 76.5T480-392Zm0 192q-146 0-266-81.5T40-500q54-137 174-218.5T480-800q146 0 266 81.5T920-500q-54 137-174 218.5T480-200Zm0-300Zm0 220q113 0 207.5-59.5T832-500q-50-101-144.5-160.5T480-720q-113 0-207.5 59.5T128-500q50 101 144.5 160.5T480-280Z"></path>
                    </svg>` + 'Explore';


    let link = '/collections/' + option.toLowerCase().replaceAll(' ', '-');
    if (!option.includes("server")) {
        link = '/collections/' + option.toLowerCase().replaceAll(' ', '-') + '-servers';
    }
    configureButton.addEventListener('click', () => window.location.href = link);
    card.appendChild(configureButton);

    return card;
}

function appendSolutionCards() {
    const solutionsContainer = document.getElementById('category-solutions');
    if (!solutionsContainer) return;
    const solutionOptions = [
        'Database', 'NAS', 'Virtualization', 'Media', 'Surveillance', 'Application Hosting', 'Gaming', 'Data Science', 'Development and Testing', 'IoT Device Management', 'Video Streaming', 'AI and Machine Learning'
    ];

    
    const solutionIcons = questions.find(q => q.key === 'selected_solution').icons;
    
    solutionOptions.forEach(option => {
        const card = createSolutionCard(option, solutionIcons[option]);
        solutionsContainer.appendChild(card);
    });
}

let funFactIndex = 0;
let funFactInterval;

function loadQuestion() {
    const questionEl = document.getElementById('question');
    const contextEl = document.getElementById('context');
    const optionsEl = document.getElementById('options');
    const backButton = document.getElementById('back-button');
    if (!questionEl || !contextEl || !optionsEl || !backButton) return;

    if (quizData.currentQuestion === 0 && backButton) {
        backButton.style.display = 'none';
    } else {
        if (backButton) backButton.style.display = 'flex';
    }
    
    const nextButton = document.getElementById('next-button');
    questionEl.classList.add('fade');
    contextEl.classList.add('fade');
    optionsEl.classList.add('fade');

    questionEl.classList.remove('fade-in');
    contextEl.classList.remove('fade-in');
    optionsEl.classList.remove('fade-in');
    questionEl.classList.add('fade-out');
    contextEl.classList.add('fade-out');
    optionsEl.classList.add('fade-out');

    setTimeout(() => {
        const questionData = questions[quizData.currentQuestion];
        optionsEl.innerHTML = '';
        nextButton.disabled = true;
        nextButton.textContent = quizData.currentQuestion < questions.length - 1 ? 'Next' : 'Submit';

        document.getElementById('loading-container').style.display = 'none';

        questionEl.textContent = questionData.question;

        if (questionData.context) {
            contextEl.textContent = questionData.context;
        }

        questionData.options.forEach(option => {
            const optionBtn = document.createElement('button');
            optionBtn.classList.add(option.replaceAll(' ', '-') + '-option');
            optionBtn.textContent = option;
            optionBtn.setAttribute('role', 'button');
            optionBtn.setAttribute('tabindex', '0');
            optionBtn.setAttribute('aria-selected', 'false');
            optionBtn.setAttribute('aria-selected', 'true');
            optionBtn.addEventListener('keypress', (e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    selectOption(optionBtn, option);
                }
            });
            if (questionData.icons && questionData.icons[option]) {
                optionBtn.innerHTML = questionData.icons[option] + option;
            }
            if (questionData.optContext && questionData.optContext[option]) {
                optionBtn.innerHTML += `<div class="option-context">${questionData.optContext[option]}</div>`;
                optionBtn.classList.add('context-option');
            }
            optionBtn.classList.add('option-button');
            optionBtn.addEventListener('click', () => selectOption(optionBtn, option));
            optionsEl.appendChild(optionBtn);
        });

        questionEl.classList.remove('fade-out');
        contextEl.classList.remove('fade-out');
        optionsEl.classList.remove('fade-out');
        questionEl.classList.add('fade-in');
        contextEl.classList.add('fade-in');
        optionsEl.classList.add('fade-in');
    }, 250); 
}

function selectOption(button, option) {
    const questionData = questions[quizData.currentQuestion];
    const nextButton = document.getElementById('next-button');

    if (questionData.type === 'single') {
        const buttons = document.querySelectorAll('.option-button');
        buttons.forEach(btn => btn.classList.remove('selected'));

        button.classList.add('selected');
        quizData.answers[questionData.key] = option;
        nextButton.disabled = false;

    } else if (questionData.type === 'multiple') {
        button.classList.toggle('selected');

        if (!Array.isArray(quizData.answers[questionData.key])) {
            quizData.answers[questionData.key] = [];
        }

        const selectedOptions = quizData.answers[questionData.key];

        if (button.classList.contains('selected')) {
            if (!selectedOptions.includes(option)) {
                selectedOptions.push(option);
            }
        } else {
            const index = selectedOptions.indexOf(option);
            if (index > -1) {
                selectedOptions.splice(index, 1);
            }
        }

        nextButton.disabled = selectedOptions.length === 0;
    }
}

function proceedToNextQuestion() {
    if (quizData.currentQuestion !== 0) {
        if (window.innerWidth < 768) {
            document.getElementById('back-button').style.display = 'flex';
            document.getElementById('quiz-container').scrollIntoView({ behavior: 'smooth' });

        }
    }
    if (quizData.currentQuestion < questions.length - 1) {
        quizData.currentQuestion++;
        loadQuestion();
    } else {
        submitQuiz();
    }

}

function goToPreviousQuestion() {
    if (quizData.currentQuestion > 0) {
        quizData.currentQuestion--;
        loadQuestion();
        
        // Restore previous selections
        const questionData = questions[quizData.currentQuestion];
        const selectedOptions = quizData.answers[questionData.key];
        
        setTimeout(() => {
            const optionButtons = document.querySelectorAll('.option-button');
            
            optionButtons.forEach(button => {
                const optionText = button.textContent.trim();
                
                if (questionData.type === 'single' && selectedOptions === optionText) {
                    button.classList.add('selected');
                    document.getElementById('next-button').disabled = false;
                } else if (questionData.type === 'multiple' && Array.isArray(selectedOptions)) {
                    if (selectedOptions.includes(optionText)) {
                        button.classList.add('selected');
                        document.getElementById('next-button').disabled = false;
                    }
                }
            });
        }, 300); //  delay to ensure DOM is updated
    }
}

let attempt = 0;    

function setLoading() {
    const questionEl = document.getElementById('question');
    const optionsEl = document.getElementById('options');
    const contextEl = document.getElementById('context');

    questionEl.textContent = 'Configuring your configuration...';
    contextEl.textContent = '';
    document.getElementById('options').innerHTML = '';
    document.getElementById('options').style.minHeight = '0';

    document.getElementById('button-container').style.display = 'none';
    document.getElementById('loading-container').style.display = 'block';

    startFunFactsRotation();
}

function submitQuiz() {
    const questionEl = document.getElementById('question');
    const optionsEl = document.getElementById('options');
    const contextEl = document.getElementById('context');

    optionsEl.classList.add('fade-out');
    setTimeout(() => {
    console.time('submitQuiz');
    setLoading();

    //console.log('Submitting quiz:', quizData.answers);

    const endpoint = 'https://apiapi.ombligo.com/quiz/';
    fetch(endpoint, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(quizData.answers)
    })
    .then(response => response.json())
    .then(data => {

        attempt = 0;
        //console.log('Response from server:', data);
        stopFunFactsRotation();
        displayCompletionMessage(data);

        console.timeEnd('submitQuiz');
    })
    .catch(error => {

        attempt++;
        if (attempt < 30) {
            submitQuiz();
        } else {

            console.error('Error:', error);
            stopFunFactsRotation();
            document.getElementById('quiz-container').innerHTML = '<h2>Sorry, an error occurred. Please try again later.</h2>';
        }
    });
}, 300);
}

function startFunFactsRotation() {
    const funFactEl = document.getElementById('fun-fact');
    let funFactCounter = 0;
    funFacts.sort(() => Math.random() - 0.5);
    funFactEl.textContent = funFacts[funFactIndex];

    funFactInterval = setInterval(() => {
        if (funFactCounter % 3 === 0 && loadingList.length > 0) {
            funFactEl.textContent = loadingList[funFactCounter / 3 % loadingList.length];
        } else {
            funFactIndex = (funFactIndex + 1) % funFacts.length;
            funFactEl.textContent = funFacts[funFactIndex];
        }
        funFactCounter++;
    }, 3000);
}


function stopFunFactsRotation() {
    clearInterval(funFactInterval);
}

const parseProductDataMyRack = (data) => {
    if (!data || !data.products || !data.products.edges) return [];

    const products = [];

    for (const product of data.products.edges) {
        const node = product.node;
        const firstVariant = node.variants.edges.length ? node.variants.edges[0].node : null;

        let prodTitle = node.title;

        if (node.tags) {
            for (let tag of node.tags) {
                if (tag.includes('cto_title')) {
                    prodTitle = tag.split('=')[1];
                }
            }
        }

        products.push({
            sku: firstVariant ? firstVariant.sku : null,
            title: prodTitle.replace('"', ''),
            tags: node.tags,
            handle: node.handle,
            price: firstVariant ? firstVariant.price.amount : null,
        });
    }
    return products; 
};


const fetchProdBySKU = async (qs, type) => {
    const domain = 'techmikeny-dev.myshopify.com';
    const storefrontAccessToken = 'c10e82378c6bdb525376d21e11afdc9f';
    let queryString = '';
    if (type === 'sku') {
        queryString = `sku:${qs}`;
    } else {
        if (qs.includes('/')) {
            qs = qs.split('/')[0];
        }
        queryString = `title:${qs}`;
    }
    const query = `
    {
        products(first: 10, query: "${qs.trim()}, -product_type:server") {
            edges {
                node {
                    id
                    title
                    description
                    totalInventory
                    handle
                    tags
                    variants(first: 10) {
                        edges {
                            node {
                                id
                                title
                                sku
                                price {
                                    amount
                                }
                            }
                        }
                    }

                }
            }
        }
    }
    `;

    try {
        const response = await fetch(`https://${domain}/api/2024-07/graphql.json`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Shopify-Storefront-Access-Token': storefrontAccessToken,
            },
            body: JSON.stringify({ query }),
        });
        const data = await response.json();
        let products =  parseProductDataMyRack(data.data);

        for (let product of products) {
            //console.log(product.sku);
            //console.log(qs);
            if (product.sku === qs) {
                let prod = [];
                prod.push(product);
                 return prod;
            }
        }
        return products;
    } catch (error) {
        console.error('Error fetching product:', error);
        return null;
    }
};

    


const modifyThis = (index) => {
    const button = document.getElementById(`configure-${index}`);
    const server = JSON.parse(button.getAttribute('data-modify'));
    localStorage.setItem('build', JSON.stringify(server));
    window.location.href = `/products/${server.chassis.sku}/modify`;
};

const replaceSkuWithTitle = async (tableId) => {
    const table = document.getElementById(tableId);
    const rows = table.getElementsByClassName('MPRow');

    for (let row of rows) {
        const keyCell = row.querySelector('.MPKeyCell');
        const valueCell = row.querySelector('.MPValueCell');

        if (valueCell && valueCell.textContent.includes('SKU')) {
            const sku = valueCell.textContent.split('x ')[1];
            const productData = await fetchProdBySKU(sku, 'sku');

            if (productData && productData.title) {
                valueCell.textContent = valueCell.textContent.replace(sku, productData.title);
            }
        }
    }
};



const createTr = (key, value) => {
    if (!value) return null;
    if (value === 'None') return null;
    if (value == null) return null;
    if (value == undefined) return null;
    if (value == '') return null;
    if (value == 'N/A') return null;

    const tr = document.createElement('tr');
    tr.classList.add('MPRow');
    const keyTd = document.createElement('td');
    keyTd.classList.add('MPKeyCell');
    keyTd.textContent = key;
    const valueTd = document.createElement('td');
    valueTd.classList.add('MPValueCell');
    valueTd.textContent = value;
    tr.appendChild(keyTd);
    tr.appendChild(valueTd);
    return tr;
};


const createMpCardSkeleton = (server, index) => {
    const card = document.createElement('div');
    card.classList.add('mikes-pick-container', 'flCol');
    card.id = `mikes-pick-container-${server.chassis}`;

    const title = document.createElement('div');
    title.classList.add('mikes-pick-title');
    title.innerHTML = server.chassis.title;
    card.appendChild(title);

    const tableContainer = document.createElement('div');
    tableContainer.classList.add('mikes-pick-table-container');
    const table = document.createElement('table');
    table.classList.add('mikes-pick-table');

    const tbody = document.createElement('tbody');
    tbody.id = `quizResp-${index}`;

    tbody.appendChild(createTr('Processor', `${server.processor.qty}x ${server.processor.title}`));
    tbody.appendChild(createTr('RAM', `${server.ram.qty}x ${server.ram.title}`));
    tbody.appendChild(createTr('RAID', `${server.raid.qty}x ${server.raid.title}`));
    tbody.appendChild(createTr('Storage', `${server.storage.qty}x ${server.storage.title}`));
    if (server.dcrd && server.dcrd.qty && server.rail.title) tbody.appendChild(createTr('NDC', `${server.dcrd.qty}x ${server.dcrd.title}`));
    if (server.rail && server.rail.qty && server.rail.title) tbody.appendChild(createTr('Rail', `${server.rail.qty}x ${server.rail.title}`));
    if (server.bezel && server.bezel.qty && server.bezel.title) {
        tbody.appendChild(createTr('Bezel', `${server.bezel.qty}x ${server.bezel.title}`));
    }
    table.appendChild(tbody);
    tableContainer.appendChild(table);
    card.appendChild(tableContainer);

    const price = document.createElement('div');
    price.classList.add('mikes-pick-price');
    price.textContent = parseFloat(server.chassis.price.toFixed(2)).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    card.appendChild(price);

    const configureButton = document.createElement('div');
    configureButton.classList.add('mcc-configure-button');
    configureButton.id = `configure-${index}`;
    configureButton.setAttribute('data-modify', JSON.stringify(server));
    configureButton.textContent = 'Configure';
    configureButton.addEventListener('click', () => modifyThis(index));
    card.appendChild(configureButton);

    return card;
};


const createMpCard = async  (server, index) => {  
    const card = document.createElement('div');
    card.classList.add('mikes-pick-container', 'flCol');
    card.id = `mikes-pick-container-${server.chassis.sku}`;

    const title = document.createElement('div');
    title.classList.add('mikes-pick-title');
    title.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" height="32px" viewBox="0 -960 960 960" width="32px" fill="#0095ff">
            <path d="M480-340q33 0 56.5-23.5T560-420q0-33-23.5-56.5T480-500q-33 0-56.5 23.5T400-420q0 33 23.5 56.5T480-340ZM160-120q-33 0-56.5-23.5T80-200v-440q0-33 23.5-56.5T160-720h160v-80q0-33 23.5-56.5T400-880h160q33 0 56.5 23.5T640-800v80h160q33 0 56.5 23.5T880-640v440q0 33-23.5 56.5T800-120H160Zm0-80h640v-440H160v440Zm240-520h160v-80H400v80ZM160-200v-440 440Z"></path>
        </svg>
        ` + server.chassis;
    card.appendChild(title);

    const tableContainer = document.createElement('div');
    tableContainer.classList.add('mikes-pick-table-container');
    const table = document.createElement('table');
    table.classList.add('mikes-pick-table');

    const tbody = document.createElement('tbody');
    tbody.id = `quizResp-${index}`;
    let SKUTitle = await fetchProdBySKU(server.processor.sku, 'sku')
    tbody.appendChild(createTr('Processor', `${server.processor.qty}x ${SKUTitle[0].title}`));
    SKUTitle = await fetchProdBySKU(server.ram.sku, 'sku')

    tbody.appendChild(createTr('RAM', `${server.ram.qty}x ${server.ram.title}`));
    tbody.appendChild(createTr('RAID', `${server.raid.qty}x ${server.raid.sku}`));
    tbody.appendChild(createTr('Storage', `${server.storage.qty}x ${server.storage.sku}`));
    if (server.dcrd && server.dcrd.qty && server.rail.sku) tbody.appendChild(createTr('NDC', `${server.dcrd.qty}x ${server.dcrd.sku}`));
    if (server.rail && server.rail.qty && server.rail.sku) tbody.appendChild(createTr('Rail', `${server.rail.qty}x ${server.rail.sku}`));
    if (server.bzl && server.bzl.qty && server.bzl.sku) {
        tbody.appendChild(createTr('Bezel', `${server.bzl.qty}x ${server.bzl.sku}`));
    }
    
    table.appendChild(tbody);
    tableContainer.appendChild(table);
    card.appendChild(tableContainer);

    const price = document.createElement('div');
    price.classList.add('mikes-pick-price');
    price.textContent = '$1MM';
    card.appendChild(price);

    const configureButton = document.createElement('div');
    configureButton.classList.add('mcc-configure-button');
    configureButton.id = `configure-${index}`;
    configureButton.setAttribute('data-modify', JSON.stringify(server));
    configureButton.textContent = 'Configure';
    configureButton.addEventListener('click', () => modifyThis(index));
    card.appendChild(configureButton);

    return card;
};





function resetQuiz() {
    localStorage.removeItem('quizData');
    localStorage.removeItem('quizServers');

    const quizContainer = document.getElementById('quiz-container');
    while (quizContainer.firstChild) {
        quizContainer.removeChild(quizContainer.firstChild);
    }

    quizData.currentQuestion = 0;
    quizData.answers = {
        customer_type: '',
        selected_solution: '',
        selected_emphasis: []
    };
    window.scrollTo(0, 0);
    createQuiz();
    loadQuestion();
}

const typewriterEffect = (element, text, delay = 50) => {
    let index = 0;
    const interval = setInterval(() => {
        element.textContent = text.slice(0, index + 1);
        index++;
        if (index >= text.length) {
            clearInterval(interval);
        }
    }, delay);
};

const contentfulDatas = async (productSKU) => {
    try {
        const response = await fetch(`https://apiapi.ombligo.com/n_contentful/specific/ctoProductDescriptionAndDocumentation/productSku/${productSKU}/`);
        const data = await response.json();
        
        const items = data.items;
        const productDescription = items[0].fields.description.content;
        const documentationLinks = items[0].fields.documentationLinks;
        const ctoProductDescription = document.getElementById('cto-product-description');

        let productDescriptionHTML = '';
        productDescription.forEach((element) => {
            productDescriptionHTML += parseRichText(element);
        });

        document.getElementById('cto-product-description').innerHTML = productDescriptionHTML;

        for (const link of documentationLinks) {
            // Replace fetchEntry with your Django API call
            const docLinkResponse = await fetch(`https://apiapi.ombligo.com/n_contentful/entry/entries/${link.sys.id}/`);
            const docLink = await docLinkResponse.json();
            
            let docLinkHTML = `
            <span class = "DoumentLinkContainer">
            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#1b98dd"><path d="M320-240h320v-80H320v80Zm0-160h320v-80H320v80ZM240-80q-33 0-56.5-23.5T160-160v-640q0-33 23.5-56.5T240-880h320l240 240v480q0 33-23.5 56.5T720-80H240Zm280-520v-200H240v640h480v-440H520ZM240-800v200-200 640-640Z"/></svg>
            <a href="${docLink.fields.linkUrl}" target="_blank">${docLink.fields.title}</a></div>`;
            document.getElementById('cto-product-documentation').innerHTML += docLinkHTML;
        }

    } catch (error) {
        //console.log('Likely No data to pull:', error);
    }
}
function showProductDescription(){
    document.getElementById("cto-product-description").classList.add("selectedTab");
    document.getElementById("cto-product-description").classList.remove("unselectedTab");

    document.getElementById("cto-product-documentation").classList.add("unselectedTab");
    document.getElementById("cto-product-documentation").classList.remove("selectedTab");

    document.getElementById("cto-build-summary").classList.add("unselectedTab");
    document.getElementById("cto-build-summary").classList.remove("selectedTab");

    document.getElementById("cto-product-description-btn").classList.add("selectedTabBtn");
    document.getElementById("cto-product-documentation-btn").classList.remove("selectedTabBtn");
    document.getElementById("cto-build-summary-btn").classList.remove("selectedTabBtn");

}
function showBuildSummary(){
    document.getElementById("cto-product-description").classList.add("unselectedTab");
    document.getElementById("cto-product-description").classList.remove("selectedTab");

    document.getElementById("cto-product-documentation").classList.add("unselectedTab");
    document.getElementById("cto-product-documentation").classList.remove("selectedTab");

    document.getElementById("cto-build-summary").classList.add("selectedTab");
    document.getElementById("cto-build-summary").classList.remove("unselectedTab");

    document.getElementById("cto-product-description-btn").classList.remove("selectedTabBtn");
    document.getElementById("cto-product-documentation-btn").classList.remove("selectedTabBtn");
    document.getElementById("cto-build-summary-btn").classList.add("selectedTabBtn");

}

function showProductDocumentation(){
    document.getElementById("cto-product-documentation").classList.add("selectedTab");
    document.getElementById("cto-product-documentation").classList.remove("unselectedTab");

    document.getElementById("cto-product-description").classList.remove("selectedTab");
    document.getElementById("cto-product-description").classList.add("unselectedTab");

    document.getElementById("cto-build-summary").classList.add("unselectedTab");
    document.getElementById("cto-build-summary").classList.remove("selectedTab");

    document.getElementById("cto-product-description-btn").classList.remove("selectedTabBtn");
    document.getElementById("cto-product-documentation-btn").classList.add("selectedTabBtn");
    document.getElementById("cto-build-summary-btn").classList.remove("selectedTabBtn");
}



function preloadImages(imageArray) {
    for (let i = 0; i < imageArray.length; i++) {
      const img = new Image();
      img.src = imageArray[i];
    }
  }
  
function createThumbnails(images) {
    const thumbnailsContainer = createElementDangerously('div', 'thumbnails-container');

    images.forEach((imageSrc, index) => {
        if (imageSrc && (index === 0 || !imageSrc.includes("no-image"))) {

            const thumbnail = createElementDangerously('img', 'thumbnail', '', {
                height: "88",
                alt: `Thumbnail ${index + 2}`,
                src: imageSrc
            });
            if (index === 0) thumbnail.classList.add('activeThumb');
            thumbnailsContainer.appendChild(thumbnail);
            preloadImages([imageSrc.replace("_200x", "_600x"), imageSrc.replace("_200x", "_600x")]);
        }
    });

    thumbnailsContainer.addEventListener('click', (event) => {
        const thumbnail = event.target.closest('.thumbnail');
        if (thumbnail) {
            document.querySelector('#version-info-image').src = thumbnail.src;
            thumbnailsContainer.querySelector('.activeThumb')?.classList.remove('activeThumb');
            thumbnail.classList.add('activeThumb');
            document.querySelector('#version-info-image').src = thumbnail.src.replace("_200x", "_600x");
            document.querySelector('#version-info-image').src = thumbnail.src.replace("_200x", "_600x");

        }
    });

    return thumbnailsContainer;
}

function createElementDangerously(tag, className, innerHTML = '', attributes = {}) {
    const element = document.createElement(tag);
    if (className) element.className = className;
    if (innerHTML) element.innerHTML = innerHTML;
    Object.keys(attributes).forEach(key => element.setAttribute(key, attributes[key]));
    return element;
}

function createProductVersionContainer() {
    const quizContainer = document.getElementById('quiz-container');


    const titleSelectImagesInfo = createElementDangerously('div', 'tsii-card flRow m0', '', { id: 'title-select-images-info' });

    const titleSelectImages = createElementDangerously('div', 'title-select-images flCol fStart', '', { id: 'title-select-images' });
    const versionTitle = createElementDangerously('h2', 'version-title w100', "TechMike's Pick For You", { id: 'version-title' });
    const versionInfoImages = createElementDangerously('span', 'version-info-images flCol', '', { id: 'version-info-images' });

    titleSelectImages.appendChild(versionTitle);
    titleSelectImages.appendChild(versionInfoImages);

    const versionActionInfoContainer = createElementDangerously('div', 'version-action-info-container flCol mVCenter', '', { id: 'version-action-info-container' });

    const versionInfo = createElementDangerously('div', 'version-info flCol ', '', { id: 'version-info' });

    const versionInfoText = createElementDangerously('div', 'version-info-text flCol vCenter', '', { id: 'version-into-text' });
    const versionInfoTitle = createElementDangerously('span', 'version-info-title', '', { id: 'version-info-title' });

    const productDetail = createElementDangerously('div', 'product-detail', '', { id: 'product-detail' });

    const productDetailTabs = createElementDangerously('div', 'product-detail-tabs', '', { id: 'product-detail-tabs' });
    const buildSummaryBtn = createElementDangerously('div', 'cto-build-summary-btn cto-tab-btn selectedTabBtn', 'Build Summary', { id: 'cto-build-summary-btn', onclick: 'showBuildSummary()' });
    const productDescriptionBtn = createElementDangerously('div', 'cto-product-description-btn cto-tab-btn', 'Build Description', { id: 'cto-product-description-btn', onclick: 'showProductDescription()' });
    const productDocumentationBtn = createElementDangerously('div', 'cto-product-documentation-btn cto-tab-btn', 'Chassis Documentation', { id: 'cto-product-documentation-btn', onclick: 'showProductDocumentation()' });

    productDetailTabs.append(buildSummaryBtn, productDescriptionBtn, productDocumentationBtn);

    const productDescription = createElementDangerously('div', 'cto-product-description unselectedTab', '{{- product.description -}}', { id: 'cto-product-description' });
    const productDocumentation = createElementDangerously('div', 'cto-product-documentation unselectedTab', '', { id: 'cto-product-documentation' });
    const buildSummary = createElementDangerously('div', 'version-info-description selectedTab', '', { id: 'cto-build-summary' });

    productDetail.append(productDetailTabs, productDescription, productDocumentation, buildSummary);

    versionInfoText.append(versionInfoTitle, productDetail);
    versionInfo.appendChild(versionInfoText);

    const priceAndBuy = createElementDangerously('div', 'PriceAndBuy flCol fCenter', '', { id: 'PriceAndBuy' });
    versionInfo.appendChild(priceAndBuy);

    versionActionInfoContainer.appendChild(versionInfo);

    titleSelectImagesInfo.append(titleSelectImages, versionActionInfoContainer);

    quizContainer.appendChild(titleSelectImagesInfo);

   // quizContainer.appendChild(container);
}
const parseProductData = (data) => {


    if (!data || !data.productByHandle) return null;

    if (data.productByHandle) {
        const product = data.productByHandle;
        const firstVariant = product.variants.edges.length ? product.variants.edges[0].node : null;
        const images = product.images.edges.map(imageEdge => ({
            url: imageEdge.node.url,
            altText: imageEdge.node.altText
        }));

        return {
            inventory: product.totalInventory,
            handle: product.handle,
            sku: firstVariant ? firstVariant.sku : null,
            images: images
        };
    }

    if (!data || !data.products || !data.products.edges) return null;

    let firstProduct = null;

    for (const product of data.products.edges) {
        const node = product.node;

        if (!firstProduct) {
            const firstVariant = node.variants.edges.length ? node.variants.edges[0].node : null;
            const images = node.images.edges.map(imageEdge => ({
                url: imageEdge.node.url,
                altText: imageEdge.node.altText
            }));

            firstProduct = {
                inventory: node.totalInventory,
                handle: node.handle,
                sku: firstVariant ? firstVariant.sku : null,
                images: images
            };
        }

        if (node.totalInventory > 0) {
            const firstVariant = node.variants.edges.length ? node.variants.edges[0].node : null;
            const images = node.images.edges.map(imageEdge => ({
                url: imageEdge.node.url,
                altText: imageEdge.node.altText
            }));

            return {
                inventory: node.totalInventory,
                handle: node.handle,
                sku: firstVariant ? firstVariant.sku : null,
                images: images
            };
        }
    }

    return firstProduct;
};


const fetchProdByTitle = async (title) => {
    const domain = 'techmikeny-dev.myshopify.com';
    const storefrontAccessToken = 'c10e82378c6bdb525376d21e11afdc9f';
    title = title.replace('Dell PowerEdge', '').trim();
    title = title.replace('HP ProLiant', '').trim();
    if (title.includes('/')){
        title = title.split('/')[0];
    }
    const query = `
    {
        products(first: 10, query: "title:${title.trim()}, product_type:server chassis") {
            edges {
                node {
                    id
                    title
                    description
                    totalInventory
                    handle
                    variants(first: 10) {
                        edges {
                            node {
                                id
                                title
                                sku

                            }
                        }
                    }
                    images(first: 5) {
                        edges {
                            node {
                                url(transform: {maxWidth: 200})
                                altText
                            }
                        }
                    }
                }
            }
        }
    }
    `;

    try {
        const response = await fetch(`https://${domain}/api/2024-07/graphql.json`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Shopify-Storefront-Access-Token': storefrontAccessToken,
            },
            body: JSON.stringify({ query }),
        });
        const data = await response.json();
        //console.log('Fetched data:', data)
        return parseProductData(data.data);
    } catch (error) {
        console.error('Error fetching product:', error);
        return null;
    }
};


const fetchProdByHandle = async (handle) => {
    //console.log('Fetching product by handle:', handle);
    const domain = 'techmikeny-dev.myshopify.com';
    const storefrontAccessToken = 'c10e82378c6bdb525376d21e11afdc9f';

    const query = `
    {
            productByHandle(handle: "${handle}") {
            id
            handle
            title
            description
            totalInventory
            variants(first: 10) {
            edges {
                node {
                id
                title
                sku
                }
            }
            }
            images(first: 5) {
            edges {
                node {
                url(transform: { maxWidth: 200 })
                altText
                }
            }
            }
        }
    }
    `;

    try {
        const response = await fetch(`https://${domain}/api/2024-07/graphql.json`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Shopify-Storefront-Access-Token': storefrontAccessToken,
            },
            body: JSON.stringify({ query }),
        });
        const data = await response.json();
        //console.log('Fetched Handle data:', data)
        return parseProductData(data.data);
    } catch (error) {
        console.error('Error fetching product:', error);
        return null;
    }
};


const setupPDPResCard = async (servers, server) => {
    //console.log('Setting up PDP Res Card:', server);
    let shopProd = await fetchProdByHandle(server.chassis.sku);
    //console.log('shopProd:', shopProd);

    if (!shopProd && server.chassis.title) {
        const splitTitle = server.chassis.title.split(' ');
        const halfIndex = Math.floor(splitTitle.length / 2);
        const firstHalf = splitTitle.slice(0, halfIndex).join(' ');
        const secondHalf = splitTitle.slice(halfIndex).join(' ');
    
        shopProd = await fetchProdByTitle(firstHalf) || await fetchProdByTitle(secondHalf);
    }
    const quizContainer = document.getElementById('quiz-container');
    const versionTitle = document.getElementById("version-title")
    const versionInfo = document.getElementById("version-info");
    const versionInfoImages = document.getElementById("version-info-images");
    const versionInfoTitle = document.getElementById("version-info-title");
    const versionInfoDescription = document.getElementById("cto-build-summary");    
    const PriceAndBuy = document.getElementById("PriceAndBuy");

    if (server && server.chassis) {
        versionTitle.textContent = versionTitle.textContent + ': ' +  server.chassis.title;
    }
    const versionInfoImage = createElementDangerously('img', 'version-info-image', '', {
            id: "version-info-image",
            height: "500",
            width: "500",
            alt: shopProd?.images[0]?.altText || '',
            src: shopProd?.images[0]?.url?.replace("_200x", "_600x") || 'https://onlineimages.techmikeny.com/oimages/generic/ics.png',
        });
        versionInfoImages.appendChild(versionInfoImage);

    document.querySelector(".thumbnails-container")?.remove();

    let thumbnails = []
    shopProd?.images?.forEach((image, index) => {
        thumbnails.push(image.url)
    });
    const thumbnailsContainer = createThumbnails(thumbnails);

    versionInfoImages.appendChild(thumbnailsContainer);

    const tableContainer = document.createElement('div');
    tableContainer.classList.add('mikes-pick-table-container');
    tableContainer.classList.add('category-spec-table-container')
    const table = document.createElement('table');
    table.classList.add('mikes-pick-table');
    table.classList.add('category-spec-table');
    const tbody = document.createElement('tbody');
    tbody.id = `mainCnfTable`;

    tbody.appendChild(createTr('Processor', `${server.processor.qty}x ${server.processor.title}`));
    tbody.appendChild(createTr('RAM', `${server.ram.qty}x ${server.ram.title}`));
    tbody.appendChild(createTr('RAID', `${server.raid.qty}x ${server.raid.title}`));
    tbody.appendChild(createTr('Storage', `${server.storage.qty}x ${server.storage.title}`));
    if (server.dcrd && server.dcrd.qty && server.rail.title && server.dcrd.title && server.dcrd.title !== undefined && server.dcrd.title !== null) tbody.appendChild(createTr('NDC', `${server.dcrd.qty}x ${server.dcrd.title}`));
    if (server.rail && server.rail.qty && server.rail.title) tbody.appendChild(createTr('Rail', `${server.rail.qty}x ${server.rail.title}`));
    if (server.bezel && server.bezel.qty && server.bezel.title) {
        tbody.appendChild(createTr('Bezel', `${server.bezel.qty}x ${server.bezel.title}`));
    }
    if (server.gpu && server.gpu.qty && server.gpu.title) {
        tbody.appendChild(createTr('GPU', `${server.gpu.qty}x ${server.gpu.title}`));
    }
    table.appendChild(tbody);
    tableContainer.appendChild(table);
    versionInfoDescription.appendChild(tableContainer);

    const priceContainer = createElementDangerously("div", "version-spec-info-price", parseFloat(server.chassis.price.toFixed(2)).toLocaleString('en-US', { style: 'currency', currency: 'USD' }));
    PriceAndBuy.appendChild(priceContainer);

    const configureButton = createElementDangerously('div', 'action-configure full-round', `
        <svg class="md-chass-configure-icon" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#fff">
            <path d="m620-284 56-56q6-6 6-14t-6-14L540-505q4-11 6-22t2-25q0-57-40.5-97.5T410-690q-17 0-34 4.5T343-673l94 94-56 56-94-94q-8 16-12.5 33t-4.5 34q0 57 40.5 97.5T408-412q13 0 24.5-2t22.5-6l137 136q6 6 14 6t14-6ZM480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/>
        </svg>Configure`);
    configureButton.addEventListener("click", () => {
        localStorage.setItem("build", JSON.stringify(server))
        window.location.href = `${window.location.origin}/products/${server.chassis.sku}/modify`;
    });

    const resetButton = createElementDangerously('div', ' full-round grey-bg action-reset', `
        <svg class="md-chass-configure-icon" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#3d4246">
            <path xmlns="http://www.w3.org/2000/svg" d="M480-80q-75 0-140.5-28.5t-114-77q-48.5-48.5-77-114T120-440h80q0 117 81.5 198.5T480-160q117 0 198.5-81.5T760-440q0-117-81.5-198.5T480-720h-6l62 62-56 58-160-160 160-160 56 58-62 62h6q75 0 140.5 28.5t114 77q48.5 48.5 77 114T840-440q0 75-28.5 140.5t-77 114q-48.5 48.5-114 77T480-80Z"/>
        </svg>Reset Quiz`);
    resetButton.addEventListener("click", () => resetQuiz());
    PriceAndBuy.appendChild(configureButton);
    PriceAndBuy.appendChild(resetButton)
    if(servers.length > 1){
        const nextButton = createElementDangerously('div', ' full-round grey-bg action-reset mt-0', `
            <svg class="md-chass-configure-icon" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#3d4246">
                <path xmlns="http://www.w3.org/2000/svg" d="M480-80q-75 0-140.5-28.5t-114-77q-48.5-48.5-77-114T120-440h80q0 117 81.5 198.5T480-160q117 0 198.5-81.5T760-440q0-117-81.5-198.5T480-720h-6l62 62-56 58-160-160 160-160 56 58-62 62h6q75 0 140.5 28.5t114 77q48.5 48.5 77 114T840-440q0 75-28.5 140.5t-77 114q-48.5 48.5-114 77T480-80Z"/>
            </svg>Regenerate`);
        nextButton.addEventListener("click", () => {
            destroyQuiz();
            createQuiz();
            setLoading();
            setTimeout(() => {
                quizContainer.innerHTML = '';

                createProductVersionContainer();
                const nextServer = servers[1]
                servers = servers.slice(1);
                if (nextServer) {
                    setupPDPResCard(servers, nextServer);

                } else {
                    displayCompletionMessage(servers);
                }
            }, 2300);
        });
        PriceAndBuy.appendChild(nextButton);
    }



    contentfulDatas(shopProd.sku);
}


async function displayCompletionMessage(servers) {
    const questionEl = document.getElementById('question');
    const optionsEl = document.getElementById('options');
    const quizContainer = document.getElementById('quiz-container');
    questionEl.classList.add('fade-out');
    optionsEl.classList.add('fade-out');

    setTimeout(() => {

        quizContainer.innerHTML = '';

        createProductVersionContainer();

        setupPDPResCard(servers, servers[0]);

        if (1==2) {
            try {
                document.getElementById('loading-container').style.display = 'none';
                document.getElementById('question').textContent = '';
            } catch (e) {
                console.error('Error:', e);
            }

            servers.forEach((server, index) => {
                const mpCard = createMpCardSkeleton(server, index);
                document.getElementById('results').appendChild(mpCard);
            });
            servers.forEach(async (server, index) => {
                const tbody = document.getElementById(`quizResp-${index}`);
                if (!tbody) return;

                
                let SKUTitle = await fetchProdBySKU(server.processor.sku, 'sku');
                const processorText = `${server.processor.qty}x ${SKUTitle[0]?.title || server.processor.title}`;
                typewriterEffect(tbody.children[0].children[1], processorText);

                // Update RAM title
                SKUTitle = await fetchProdBySKU(server.ram.sku, 'sku');
                const ramText = `${server.ram.qty}x ${SKUTitle?.title || server.ram.title}`;
                typewriterEffect(tbody.children[1].children[1], ramText);

                // Update RAID title
                SKUTitle = await fetchProdBySKU(server.raid.sku, 'sku');
                const raidText = `${server.raid.qty}x ${SKUTitle[0]?.title || server.raid.title}`;
                typewriterEffect(tbody.children[2].children[1], raidText);

                // Update Storage title
                SKUTitle = await fetchProdBySKU(server.storage.sku, 'sku');
                const storageText = `${server.storage.qty}x ${SKUTitle[0]?.title || server.storage.title}`;
                typewriterEffect(tbody.children[3].children[1], storageText);

                if (server.dcrd && tbody.children[4]) {
                    SKUTitle = await fetchProdBySKU(server.dcrd.sku, 'sku');
                    const ndcText = `${server.dcrd.qty}x ${SKUTitle[0]?.title || server.dcrd.title}`;
                    typewriterEffect(tbody.children[4].children[1], ndcText);
                }

                if (server.rail && tbody.children[5]) {
                    SKUTitle = await fetchProdBySKU(server.rail.sku, 'sku');
                    const railText = `${server.rail.qty}x ${SKUTitle[0]?.title || server.rail.title}`;
                    typewriterEffect(tbody.children[5].children[1], railText);
                }

                if (server.bzl && tbody.children[6]) {
                    SKUTitle = await fetchProdBySKU(server.bzl.sku, 'sku');
                    const bezelText = `${server.bzl.qty}x ${SKUTitle[0]?.title || server.bzl.title}`;
                    typewriterEffect(tbody.children[6].children[1], bezelText);
                }

            
            });
        
            const nextButton = document.getElementById('next-button');
            nextButton.style.display = 'block';
            nextButton.disabled = false;
            nextButton.textContent = 'Restart Quiz';

            const newNextButton = nextButton.cloneNode(true);
            nextButton.parentNode.replaceChild(newNextButton, nextButton);
            newNextButton.addEventListener('click', resetQuiz);
        }
    }, 250);
}




if (localStorage.getItem('quizData') && localStorage.getItem('quizServers')) {

    createQuiz();
    document.getElementById('loading-container').style.display = 'none';
    document.getElementById('question').textContent = '';
    document.getElementById('options').innerHTML = '';
    document.getElementById('next-button').style.display = 'none';

    displayCompletionMessage(JSON.parse(localStorage.getItem('quizServers')));

} else {

    createQuiz();
    loadQuestion();

}    


function createQuiz() {
    const quizContainer = document.getElementById('quiz-container');


    const results = createElement('div', { id: 'results', className: 'results' });
    const question = createElement('div', { id: 'question', className: 'question' });
    const context = createElement('div', { id: 'context', className: 'context' });
    const options = createElement('div', { id: 'options', className: 'options' });

    const nextButton = createElement('button', { id: 'next-button', disabled: true }, 'Next');
    nextButton.addEventListener('click', proceedToNextQuestion);
    const backButton = createElement('button', { id: 'back-button', className: 'back-button' }, 'Back');
    backButton.addEventListener('click', goToPreviousQuestion);
    backButton.style.display = 'none'; 
    
    const buttonContainer = createElement('div', { id: 'button-container' });
    buttonContainer.append(backButton, nextButton);

    const loadingContainer = createElement('div', { id: 'loading-container' });
    const spinner = createElement('div', { className: 'spinner' });
    const funFact = createElement('div', { id: 'fun-fact' });

    loadingContainer.append(spinner, funFact);
    
    if (quizContainer) quizContainer.append(results, question, context, options, buttonContainer, loadingContainer);
    let optionsElement = document.getElementById('options');
    if (optionsElement) optionsElement.style.minHeight = '100px';


    

}

function destroyQuiz() {
    document.getElementById('quiz-container').innerHTML = '';
}




async function setupCTOContentResources(data) {
    var CTOContentResourcesContainer = document.querySelector('#tt-resources');
    var resourceData = data;
    var resourceLink = resourceData.linkToResource;
    var resourceDescription = resourceData.description.content;

    var image = await fetchEntry("assets", resourceData.image.sys.id);
    var imageURL = image.fields.file.url.replace('//', 'https://');
    var imageDescription = image.fields.description;

    var parsedDescription = '';

    
    resourceDescription.forEach(node => {
        parsedDescription += parseRichText(node);
    });

    const resourceContainer = document.createElement('div');
    resourceContainer.classList.add('resourceContainer');

    const resourceImageContainer = document.createElement('div');
    resourceImageContainer.classList.add('resourceImageContainer');
    

    const resourceImage = document.createElement('img');
    resourceImage.src = imageURL + '?w=159';
    resourceImage.alt = imageDescription;
    resourceImage.classList.add('resourceImage');
    resourceImage.classList.add('lazyload');
    resourceImage.srcset = `
        ${imageURL}?w=159 159w,
        ${imageURL}?w=318 318w,
        ${imageURL}?w=300 480w,
        `;
    resourceImage.sizes = '(max-width: 159px) 159px, (max-width: 318px) 318px, (max-width: 480px) 480px';
    resourceImage.width = '159';
    resourceImage.height = '159';
    const resourceTitle = document.createElement('h3');
    resourceTitle.classList.add('resourceTitle');
    resourceTitle.innerHTML = resourceData.title;

    const resourceDescriptionContainer = document.createElement('div');
    resourceDescriptionContainer.classList.add('resourceDescriptionContainer');
    resourceDescriptionContainer.innerHTML = parsedDescription;

    const resourceLinkElem = document.createElement('a');
    resourceLinkElem.classList.add('resourceLink');
    resourceLinkElem.href = resourceLink;
    resourceLinkElem.title = resourceData.title;

    resourceImageContainer.appendChild(resourceImage);
    resourceLinkElem.appendChild(resourceImageContainer);
    resourceLinkElem.appendChild(resourceTitle);
    resourceLinkElem.appendChild(resourceDescriptionContainer);
    resourceContainer.appendChild(resourceLinkElem);
    CTOContentResourcesContainer.appendChild(resourceContainer);
}





document.addEventListener("DOMContentLoaded", async function() {
    let categoryTitleEl = document.getElementById("category-title");
    let categoryContextEl = document.getElementById("category-context");
    let categorySolutionsEl = document.getElementById("category-solutions");
    let ttTitleEl = document.getElementById("tt-title");
    let ttContextEl = document.getElementById("tt-context");
    let otherShoppingTitleEl = document.getElementById("other-shopping-title");
    let otherShoppingContextEl = document.getElementById("other-shopping-context");
    let valueTitleEl = document.getElementById("value-title");
    let valueContextEl = document.getElementById("value-context");

    let contentfulCore = await fetchEntry('entries', '1XjGLxx9Ppf9RjilePne1T')
    //console.log(contentfulCore);
    if(categoryTitleEl) categoryTitleEl.innerHTML = contentfulCore.fields.categoryTitle;

    if (categoryContextEl) categoryContextEl.innerHTML = richText(contentfulCore.fields.categoryContext.content);

    if (ttTitleEl) ttTitleEl.innerHTML = contentfulCore.fields.techTalkContextHeader;
    if (ttContextEl) ttContextEl.innerHTML = richText(contentfulCore.fields.techTalkContextContext.content);

    if (otherShoppingTitleEl) otherShoppingTitleEl.innerHTML = contentfulCore.fields.otherShoppingTitle;
    if (otherShoppingContextEl) otherShoppingContextEl.innerHTML = richText(contentfulCore.fields.otherShoppingContext.content);

    if (valueTitleEl) valueTitleEl.innerHTML = contentfulCore.fields.valueTitle;
    if (valueContextEl) valueContextEl.innerHTML = richText(contentfulCore.fields.valueContext.content);

    retrieveLinkedTechTalks(contentfulCore.fields.techTalkResources);
    appendSolutionCards()
});






